<template>
  <v-app style="width: 100%">
    <v-app-bar dense color="white" elevation="2" v-if="isMobile" :app="true" >
      <v-list-item class="mr-2 ml-0 pl-0">
        <v-list-item-icon>
           <a href="/">
            <v-img aspect-ratio="1" width="50px" :src="logo"></v-img>
           </a>
        </v-list-item-icon>

        <v-list-item-title class="title mx-5">NSUK Portal</v-list-item-title>
      </v-list-item>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main style="width: 100%; overflow-x: hidden;" :class="{'g': isMobile,'q': isMediumAndUp}">
      <Login/>
    </v-main>
  </v-app>
</template>

<script>
import AppTypes from 'shared/constants/apptypes';
import Login from './components/Auth';
import Api from '@/main/api';
import Links from '@/shared/constants/Links';
import Defaults from '@/shared/Defaults';
import ErrorResolver from '@/shared/ErrorResolver';
import LoginUtil from "@/login/LoginUtil";
import SupportWidget from "@/shared/StudentSupportWidget";
export default {
  name: 'App',

  components: {
    Login,
  },

  data: () => ({
    logo: '',
    title: ""
  }),

  methods:{
    fetchGlobal() {
      const app = AppTypes.CURRENT === AppTypes.FPN;
      Api.global.fetch().then((res) => {
        this.logo = Defaults.api + Links.global.logo;

        if(app){
          document.title = res.data.institutionName;
        }

        return undefined;
      }).catch((err) => ErrorResolver.checkErrors(this, err))
    },

    loadScripts(){
      Api.support.all() 
        .then((res) => {
          // const head = document.getElementsByTagName("head")[0]
          console.log(res.data)
          for (let i = 0; i < res.data.length; i++){
            eval(res.data[i].script)
          }
        })
        .catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => {
          this.loading = false; 
        })
    }
  },

  mounted() {
    this.fetchGlobal();
    SupportWidget.initGuest();
  },

  beforeDestroy() {
    SupportWidget.destroy();
  },


  computed: {
    isMobile: function(){
      return this.$vuetify.breakpoint.smAndDown
    },

    isMediumAndUp: function(){
      return this.$vuetify.breakpoint.mdAndUp
    },
  },

  created() {
    LoginUtil.resetAccessToken()
    LoginUtil.resetRefreshToken()
    this.loadScripts()
  },

};
</script>

<!-- <style scoped>
  .g{
    background-color: #F5F5F5;
  }

  .q{
    background-color: white;
  }
</style> -->
